export const BRAND = {
  name: "MUFA POS",
  tagline: "Software Kasir Modern",
  logoFull: "/brand/logo-full.png",
  logoMark: "/brand/logo-mark.png",
};

export const homePath = (u) => {
  const p = u?.permissions || [];
  if (p.includes("reports")) return "/dashboard";
  if (p.includes("pos")) return "/kasir";
  return "/transaksi";
};
